import React from 'react'
import Head from 'next/head'
import Pitch from '@src/components/DisposalPage/Pitch'
import FeatureList from '@src/components/DisposalPage/FeatureList'
import Approach from '@src/components/DisposalPage/Approach'
import CaseStudy from '@src/components/DisposalPage/CaseStudy'
import FAQ from '@src/components/DisposalPage/FAQ'
import SchemaMarkup from '@src/components/SchemaMarkup'
import RelatedServices from '@src/components/RelatedServices'
import Clients from '@src/pages/LandingPage/Clients'
import Testimonials from '@src/pages/LandingPage/Testimonials'
import junkTestimonials from '@src/constants/junkTestimonials'
import TrustBox from '@src/pages/common/components/TrustBox'
import TrustedByClients from '@src/components/DisposalPage/TrustedByClients'
import pageClasses from '@src/styles/junk-removal-page.module.css'
// eslint-disable-next-line import/extensions
import commercial from '../../json/commercial-waste-disposal-data.json'

const commercialServiceData = {
  name: 'Commercial Waste Disposal Services',
  description:
    'Nationwide commercial waste disposal and recycling for restaurants, retail, offices, warehouses, and property managers. One-time or recurring collection, 15% off scheduled services, 10% off services over $800, and a diversion report every visit.',
  serviceType: 'Commercial Waste Disposal',
  url: 'https://getdimension.com/commercial-waste-disposal',
  provider: {
    name: 'Dimension',
    url: 'https://getdimension.com',
    address: {
      streetAddress: '2261 Market Street, #4061',
      addressLocality: 'San Francisco',
      addressRegion: 'CA',
      postalCode: '94114',
      addressCountry: 'US',
    },
    telephone: '+1 (415) 340-7182',
  },
  offers: [
    { name: 'Commercial Waste Collection' },
    { name: 'Commercial Recycling Collection' },
    { name: 'Recurring Business Waste Service' },
    { name: 'Multi-Location Waste Management' },
    { name: 'Commercial Bulky Item Removal' },
  ],
}

const commercialFAQData = {
  questions: commercial.FAQContent.contentList.map((faq) => ({
    question: faq.heading.replace(/<[^>]*>/g, ''),
    answer: faq.textList.join(' '),
  })),
}

function CommercialWasteDisposal() {
  return (
    <>
      <Head>
        <title>Commercial Waste Disposal Services | Dimension</title>
        <meta
          name="description"
          content="Commercial waste disposal and recycling nationwide for restaurants, retail, offices, and warehouses. Instant pricing, up to 25% off, one account per business."
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="canonical" href="https://getdimension.com/commercial-waste-disposal" />
        <SchemaMarkup type="WebSite" />
        <SchemaMarkup type="Service" data={commercialServiceData} />
        <SchemaMarkup type="FAQPage" data={commercialFAQData} />
        <SchemaMarkup type="LocalBusiness" />
      </Head>
      <div className={pageClasses.root}>
        <Pitch
          variant="hazardous-waste"
          heroImage="junk"
          heading={commercial.pitch.heading}
          material={commercial.pitch.material}
          pitchText={commercial.pitch.pitchText}
          ctaLink={commercial.pitch.ctaLink}
          ctaText={commercial.pitch.ctaText}
          ctaHeading={commercial.pitch.ctaHeading}
          ctaSubtext={commercial.pitch.ctaSubtext}
          belowCta={<TrustBox isMobile isDark={false} />}
          belowPitch={<TrustedByClients />}
        />
        <Testimonials testimonials={junkTestimonials} />
        <Clients />
        <FeatureList {...commercial.solutions} />
        <FeatureList {...commercial.benefits} />
        <CaseStudy {...commercial.caseStudy} />
        <Approach {...commercial.approach} />
        <FAQ {...commercial.FAQContent} />
        <RelatedServices
          services={[
            {
              label: 'Recurring Waste Services',
              href: '/recurring-waste-services',
              description:
                'How scheduled collection works — cadences, arrival windows, and the 15% recurring discount.',
            },
            {
              label: 'Cardboard Recycling',
              href: '/cardboard-recycling',
              description:
                'Dedicated cardboard collection at warehouse and retail volume, with no material surcharge.',
            },
            {
              label: 'Dumpster Swaps',
              href: '/dumpster-swaps',
              description:
                'Container exchanges for sites that fill a roll-off faster than a rental period.',
            },
            {
              label: 'Other Hazardous Waste',
              href: '/other-hazardous-waste',
              description:
                'Where solvents, chemicals, batteries, and other regulated material go instead of a general load.',
            },
          ]}
        />
      </div>
    </>
  )
}

export default CommercialWasteDisposal
